export const getItemIdentifier = (item: any) => {
  const id = item?.slug ?? item?._id ?? '';

  if (id === null || id === undefined || id === 'null') {
    return '';
  }

  return String(id);
};

export const getCollectionIdentifier = (item: any) => {
  return item?.slug ?? item?.name ?? item?._id ?? '';
};
